import {BruteForceSymbol, BruteForceSymbolStates} from "./BruteForceSymbol";
import {SimpleReelModel, SimpleReelModelSymbolPosition} from "../../core/reel/simplereel/SimpleReelModel";
import {BruteForce} from "../BruteForce";
import {gsap} from "gsap";
import {BruteForceHelper} from "../utils/BruteForceHelper";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BruteForceGameConfig} from "../BruteForceGameConfig";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {BLEND_MODES} from "pixi.js";
import {BruteForceSound} from "../sound/BruteForceSound";


export class BruteForceXNudgeSymbol extends BruteForceSymbol {

    private _toNudgeDown: boolean = false;
    private _nudgeHeight: number;
    private _meterSpine: PIXI.spine.Spine;
    private _multiplierContainer: PIXI.Container;
    private _multiplierX: PIXI.Text;
    private _nudgeMultiplier: PIXI.Text;
    private _stepIncreaseNumber: number;
    private _currentMultiplierValue: number;
    private _meterGlow: PIXI.spine.Spine;
    private _meterNeedle: PIXI.Sprite;
    private _maxMultiplier: PIXI.Text;
    private _nudgeType: number;
    private _nudgeLogo: PIXI.Sprite;
    private _nudgeWinFire: TimelineSprite;
    private _lockContainer: PIXI.Container;
    private _nudgeReelOverlay: PIXI.Sprite;

    constructor(symbolName: string, symPos: SimpleReelModelSymbolPosition, symbolState: BruteForceSymbolStates) {
        symbolName = `XN_${BruteForce.model.xNudgeLevels[symPos.reelID]}`;
        if (BruteForce.model.xNudgeLevels[symPos.reelID] === 0) {
            //debugger;
            symbolName = "XN_1";
        }
        super(symbolName, symPos, symbolState);
        this._nudgeType = BruteForce.model.xNudgeLevels[symPos.reelID] === 0 ? 1 : BruteForce.model.xNudgeLevels[symPos.reelID];
        this._spine.position.y = 192;
        if (symbolState === BruteForceSymbolStates.SPIN) {
            this._spine.position.y = 0;
        }

        this._lockContainer = new PIXI.Container();
        this._spine.addChild(this._lockContainer);

        this._nudgeWinFire = new TimelineSprite(BruteForce.assetLoader.getTextures("nudgeFireHighlight"))
        this._nudgeWinFire.position.set(0, 0);
        this._nudgeWinFire.anchor.set(0.5, 0.5);
        this._nudgeWinFire.name = "fireFrames";
        this._nudgeWinFire.hide();
        this._spine.addChild(this._nudgeWinFire);

        this._nudgeLogo = new PIXI.Sprite(BruteForce.assetLoader.getTextures("nudgeLogo")[0]);
        this._nudgeLogo.anchor.set(0.5, 0.5);
        this._nudgeLogo.position.set(20, -216);
        this._nudgeLogo.name = "nudgeLogo";
        this._spine.addChild(this._nudgeLogo);


        this._meterSpine = new PIXI.spine.Spine(BruteForce.assetLoader.getSpineAsset("NudgeMeterSpine"));
        this._meterSpine.name = "meter";
        this._meterSpine.position.set(0, 450);
        this._meterSpine.state.setAnimation(0, "normal", false);
        this._meterSpine.visible = false;
        //this._meterSpine.alpha = 0;

        this._meterGlow = new PIXI.spine.Spine(BruteForce.assetLoader.getSpineAsset("nudgeGlowStates"));
        this._meterGlow.name = "meterGlowStates";
        this._meterGlow.position.set(0, 0);
        //BruteForceHelper.playSpineWithTimeline(this._meterGlow, 0, "normal");
        this._meterGlow.visible = false;

        this._meterNeedle = new PIXI.Sprite(BruteForce.assetLoader.getTextures("meterNeedle")[0]);
        this._meterNeedle.name = "meter_needle";
        this._meterNeedle.position.set(10, 26);
        this._meterNeedle.scale.set(1, 1);
        this._meterNeedle.anchor.set(0.5, 0.5);
        this._meterNeedle.rotation = -Math.PI * 0.33;

        this._meterNeedle.visible = false;

        this._maxMultiplier = new PIXI.Text("", new PIXI.TextStyle(
            {
                fill: "#14E6ED",
                fontFamily: "Guardians",
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 15,
                letterSpacing: 3,
            }));

        this._maxMultiplier.position.set(-30, -7);
        this._maxMultiplier.text = BruteForceGameConfig.nudgeMaxMultiplierConfig[BruteForce.model.xNudgeLevels[symPos.reelID]].toString();
        this._maxMultiplier.visible = false;
        this._maxMultiplier.name = "maxMultiplier";
        this._maxMultiplier.pivot.x = this._maxMultiplier.width * 0.5;
        this._meterSpine.addChild(this._meterGlow, this._maxMultiplier, this._meterNeedle);

        this.addChild(this._meterSpine);

        this.addMultiplier();
        this._currentMultiplierValue = 1;
        if (BruteForce.model.gameData) {
            this.toSetSymbolPos();
        } else {
            if (BruteForce.model.isRestore) {
                this.fixMultiplierAtbottom(BruteForce.model.xNudgeMultipliers[this.reelId]);
            } else {
                this.fixMultiplierAtbottom(BruteForceGameConfig.nudgeMaxMultiplierConfig[BruteForce.model.xNudgeLevels[symPos.reelID]]);
            }

        }

        this.setInitialIncrease(BruteForce.model.xNudgeLevels[symPos.reelID]);


        this._nudgeReelOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._nudgeReelOverlay.name = "overlay";
        this._nudgeReelOverlay.tint = 0x000000;
        this._nudgeReelOverlay.alpha = 0.4;
        this._nudgeReelOverlay.width = 120;
        this._nudgeReelOverlay.height = 480;
        this._nudgeReelOverlay.position.y = 192;
        this._nudgeReelOverlay.anchor.set(0.5, 0.5);
        this._nudgeReelOverlay.visible = false;
        this.addChild(this._nudgeReelOverlay);
    }

    get nudgeSymHeight(): number {
        return this._nudgeHeight;
    }

    get isNudgeDirectionDown(): boolean {
        return this._toNudgeDown;
    }

    get typeOfNudge(): number {
        return this._nudgeType;
    }

    public setState(state: BruteForceSymbolStates): gsap.core.Timeline {
        const stateTl: gsap.core.Timeline = gsap.timeline();
        switch (state) {
            case BruteForceSymbolStates.SPIN:
                stateTl.add(() => {
                    this._spine.tint = 0xffffff
                }, 0);
                stateTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, "spin"), 0);
                this._currentState = "spin";

                break;
            case BruteForceSymbolStates.LANDING:
                stateTl.add(() => {
                    this._spine.tint = 0xffffff;
                }, 0)
                stateTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, "landing"), 0);
                this._currentState = "landing";
                break;
            case BruteForceSymbolStates.WIN:
                stateTl.add(() => {
                    this._spine.tint = 0xffffff;
                    if (this._meterSpine) {
                        this._nudgeMultiplier.tint = 0xffffff;
                        this._maxMultiplier.tint = 0xffffff;
                        this._multiplierX.tint = 0xffffff;
                        this._meterSpine.tint = 0xffffff;
                        this._nudgeLogo.tint = 0xffffff;
                        this._nudgeReelOverlay.visible = false;
                        this._nudgeWinFire.playLoop();
                        this._nudgeWinFire.show();
                    }
                }, 0);
                if (this.currentState !== "happy") {
                    stateTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, "normal"), 0);
                    this._currentState = "win";
                }


                break;
            case BruteForceSymbolStates.NO_WIN:
                stateTl.add(() => {
                    this._spine.tint = 0x666666;
                    this._meterSpine!.tint = 0x666666;
                    this._nudgeMultiplier!.tint = 0x666666;
                    this._multiplierX.tint = 0x666666;
                    this._maxMultiplier.tint = 0x666666;
                    this._nudgeLogo.tint = 0x666666;
                    this._nudgeReelOverlay.visible = true;
                    this._nudgeWinFire.hide();
                    this._nudgeWinFire.stopLoop();
                }, 0);
                if (this.currentState !== "happy") {
                    stateTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, "normal"), 0);
                    this._currentState = "nowin";
                }

                break;
            case BruteForceSymbolStates.HAPPY:
                stateTl.add(() => {
                    this._spine.tint = 0xffffff;
                    this.resetAdditionalAssets();
                }, 0);
                stateTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, "happy"), 0);
                this._currentState = "happy";

                break;
            case BruteForceSymbolStates.SAD:
                stateTl.add(() => {
                    this._spine.tint = 0xffffff;
                    this.resetAdditionalAssets();
                }, 0);
                stateTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, "sad"), 0);
                this._currentState = "sad";

                break;
            case BruteForceSymbolStates.IDLE:
                stateTl.add(() => {
                    this._spine.tint = 0xffffff;
                    this.resetAdditionalAssets();
                }, 0);
                stateTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, "idle"), 0);
                this._currentState = "idle";

                break;
            default:
                stateTl.add(() => {
                    this._spine.tint = 0xffffff;
                    this.resetAdditionalAssets();
                }, 0);
                if (this.currentState !== "happy" && this.currentState !== "sad") {
                    stateTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, "normal"), 0);
                    this._currentState = "normal";
                }

        }
        return stateTl;
    }


    private resetAdditionalAssets(): void {
        if (this._meterSpine) {
            this._nudgeMultiplier.tint = 0xffffff;
            this._maxMultiplier.tint = 0xffffff;
            this._multiplierX.tint = 0xffffff;
            this._meterSpine.tint = 0xffffff;
            this._nudgeLogo.tint = 0xffffff;
            this._nudgeReelOverlay.visible = false;
            this._nudgeWinFire.hide();
            this._nudgeWinFire.stopLoop();
        }
    }

    public fixMultiplierAtbottom(nudgeValue: number): void { //use for normalstartup, restore and noWin XN
        this._meterSpine.visible = true;
        this._meterGlow.visible = true;
        this._meterNeedle.visible = true;
        this._maxMultiplier.visible = true;
        this._meterSpine.position.set(-2, 367);
        this._meterSpine.alpha = 1;
        this._nudgeMultiplier.text = nudgeValue.toString();
        this.adjustMultiplierText();
        this._currentMultiplierValue = nudgeValue;
        this._maxMultiplier.alpha = nudgeValue === 0 ? 1 : 0.2;
        if (this._nudgeMultiplier.text === "0") {
            this._nudgeMultiplier.alpha = 0;
        } else {
            this._nudgeMultiplier.alpha = 1;
        }

    }

    public firstNudge(): gsap.core.Timeline {
        const showMeterTl: gsap.core.Timeline = gsap.timeline();
        showMeterTl.add(() => {
            this._meterSpine.visible = true;
            this._meterGlow.visible = true;
            this._meterNeedle.visible = true;
            this._maxMultiplier.visible = true;
            this._meterSpine.position.set(-2, 680);
            this.parent.addChild(this._meterSpine);
        }, 0);
        showMeterTl.to(this._meterSpine, {alpha: 1, duration: 0.07}, 0);
        showMeterTl.to(this._meterSpine, {y: 367, duration: 0.15}, 0);
        return showMeterTl;
    }

    public multiplierIncreaseByNudge(count: number): gsap.core.Timeline {
        const incrementTl: gsap.core.Timeline = gsap.timeline();
        incrementTl.to(this, {duration: 0.05});
        incrementTl.add(() => {
            this._nudgeMultiplier.text = (this._stepIncreaseNumber * count + this._stepIncreaseNumber).toString();
            this.adjustMultiplierText();
        }, 0);
        this._currentMultiplierValue = this._stepIncreaseNumber * count + this._stepIncreaseNumber;

        return incrementTl;
    }

    public animateToFinalMutliplierValue(finalValue: number): gsap.core.Timeline {
        const multiAnim: gsap.core.Timeline = gsap.timeline();
        let currentValue: number = JSON.parse(JSON.stringify(this._currentMultiplierValue));
        const countIncrease: number = finalValue - currentValue;

        multiAnim.add(this.meterValueAddition(countIncrease));
        multiAnim.to(this._maxMultiplier, {alpha: 0.2, duration: 0.25}, "<")

        const increaseTl: gsap.core.Timeline = gsap.timeline();
        for (let i: number = 0; i <= countIncrease; i++) {
            const singleUpdate: gsap.core.Timeline = gsap.timeline();
            singleUpdate.add(() => {
                this._nudgeMultiplier.alpha = 1;
                this._nudgeMultiplier.text = (currentValue + i).toString();
                this.adjustMultiplierText();
            }, 0);
            this._currentMultiplierValue += 1;
            increaseTl.add(singleUpdate);
            increaseTl.to(this, {duration: 0.05});
        }
        increaseTl.totalDuration(0.2);
        multiAnim.add(increaseTl, 0.95);
        multiAnim.to(this, {duration: 0.3});
        return multiAnim;
    }

    public adjustMeterBackToSymbol(): gsap.core.Timeline {
        const adjustTl: gsap.core.Timeline = gsap.timeline()
        const xNudgeReel: SimpleReelModel = BruteForce.allreelsView.reelModels[this.reelId];
        adjustTl.add(() => {
            BruteForce.allreelsView.reelModels[this.reelId].reelView.nudgeContainer.addChild(this);
            this.position.set(0, 0);
            this._meterSpine.position.set(-2, 175);
            this._spine.addChild(this._meterSpine);
            this._spine.position.set(0, 192);
            xNudgeReel.updateNudgeSymPosInArray();
        }, 0);
        adjustTl.to(this, {duration: 0.05})

        return adjustTl;
    }

    public playSpineAnimation(animName: string, toLoop: boolean): gsap.core.Timeline {
        //  console.log(`>>AnimName ` + animName, "duration" + BruteForceHelper.spineAnimDuration(this._spine, animName))
        const playTl: gsap.core.Timeline = gsap.timeline();
        if (animName === "intro") {
            playTl.add(() => {

                BruteForce.reelOverlayView.addChild(this);
                this._meterSpine.position.set(-2, 175);
                this._spine.addChild(this._meterSpine);
                this._spine.position.set(0, 192);
                this.position.set(BruteForceGameConfig.reelSetPositionX + BruteForceGameConfig.symbolWidth * this.reelId - 12, 100);
            }, 0);
        }
        playTl.add(BruteForceHelper.playSpineWithTimeline(this._spine, 0, animName));
        return playTl;
    }

    public playTease(finalValue: number): gsap.core.Timeline {
        const teaseTl: gsap.core.Timeline = gsap.timeline();
        const oneRange: number = parseInt(this._maxMultiplier.text) / 6;
        const glowNo: number = Math.floor(finalValue / oneRange);

        for (let i: number = 1; i <= glowNo; i++) {
            teaseTl.add(BruteForceHelper.playSpineWithTimeline(this._meterGlow, 0, `meterGlow_lev${i}`));
            teaseTl.add(this.needleAnimation(Math.PI * 0.16 * i, 0.168 * i), "<");
        }

        teaseTl.duration(0.811);
        return teaseTl;
    }

    public setMeter(finalMultiValue: number): void {
        const rangeValue: number = parseInt(this._maxMultiplier.text) / 6;
        const glowNo: number = Math.floor(finalMultiValue / rangeValue);

        this._meterGlow.state.setAnimation(0, `meterGlow_lev${glowNo}`, false).timeScale = 5;
        this._meterNeedle.rotation = Math.PI * 0.16 * glowNo;
    }

    public meterAnimation(): gsap.core.Timeline {
        const meterTl: gsap.core.Timeline = gsap.timeline();
        meterTl.add(BruteForceHelper.playSpineWithTimeline(this._meterSpine, 0, "meterHighlight"))
        return meterTl;
    }

    public addLockAnimation(): gsap.core.Timeline {
        const lockTl: gsap.core.Timeline = gsap.timeline();
        const lockFrameSpine: PIXI.spine.Spine = new PIXI.spine.Spine(BruteForce.assetLoader.getSpineAsset("NudgeLock"));
        lockFrameSpine.name = "lockSpine";
        lockFrameSpine.position.set(0, -2);
        lockTl.add(() => {
            this._lockContainer.addChild(lockFrameSpine);
        }, 0);
        lockTl.add(BruteForceHelper.playSpineWithTimeline(lockFrameSpine, 0, "idle"), 0);
        return lockTl;


    }

    private toSetSymbolPos(): void {
        this._nudgeHeight = BruteForce.allreelsView.reelModels[this.reelId].reelView.nudgeHeight;
        if (this._nudgeHeight === 1) {
            if (this.symId === 0) {
                this._spine.position.y = -192;
                this._toNudgeDown = true;
            }
        } else if (this._nudgeHeight === 2) {
            if (this.symId === 0) {
                this._spine.position.y = -96;
                this._toNudgeDown = true;
            }
        } else if (this._nudgeHeight === 3) {
            if (this.symId === 0) {
                this._spine.position.y = 0;
                this._toNudgeDown = true;
            }
        } else if (this._nudgeHeight === 4) {
            if (this.symId === 0) {
                this._spine.position.y = 96;
                this._toNudgeDown = true;
            }
        } else if (this._nudgeHeight === 5) {
            if (this.symId === 0) {
                this._spine.position.y = 192;
                this._toNudgeDown = true;
                this.fixMultiplierAtbottom(1);
            }
        }

        //   BruteForceGameConfig.nudgeSymYPos[this.reelId] = this.loadingYPos;

    }

    private addMultiplier(): void {
        this._multiplierContainer = new PIXI.Container();
        this._multiplierContainer.name = "multiplierValue container";

        let textStyle: PIXI.TextStyle = new PIXI.TextStyle({
            fill: this._nudgeType === 1 ? "#dac014" : this._nudgeType === 2 ? "#f55b08" : "#ef162e",
            fontFamily: "AMCAP Eternal",
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 40,
            letterSpacing: 3,
        })

        this._multiplierX = new PIXI.Text("x", textStyle);
        this._multiplierX.scale.set(0.8, 0.8);
        this._multiplierX.name = "multiplierX";
        this._multiplierContainer.addChild(this._multiplierX)
        this._multiplierX.position.set(20, -54);

        this._nudgeMultiplier = new PIXI.Text("", textStyle);

        this._nudgeMultiplier.name = "totalXNudgeMultiplier";
        this._multiplierContainer.addChild(this._nudgeMultiplier);
        this._nudgeMultiplier.position.set(-18, -62);

        this._meterSpine.addChild(this._multiplierContainer);
    }

    private setInitialIncrease(symbolType: number): void {
        switch (symbolType) {
            case(1):
                this._stepIncreaseNumber = 1
                break;
            case(2):
                this._stepIncreaseNumber = 2
                break;
            case(3):
                this._stepIncreaseNumber = 5
                break;
            default:
                this._stepIncreaseNumber = 1;
                break;
        }

    }


    private needleAnimation(value: number, duration: number): gsap.core.Timeline {
        const needleTl: gsap.core.Timeline = gsap.timeline();
        needleTl.to(this._meterNeedle, {rotation: value, duration: duration, ease: "none"});
        return needleTl;
    }

    private meterValueAddition(toAddValue: number): gsap.core.Timeline {
        const valueTl: gsap.core.Timeline = gsap.timeline();
        const additionalValue: PIXI.Text = new PIXI.Text("", new PIXI.TextStyle(
            {
                fill: "#ffffff",
                fontFamily: "Guardians",
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 30,
                stroke: 0x000000,
                strokeThickness: 5,
                lineJoin: "round",
                letterSpacing: 3,
            }));
        additionalValue.pivot.x = additionalValue.width * 0.5;
        additionalValue.name = "additonalValue";
        additionalValue.text = "+" + toAddValue.toString();
        additionalValue.position.set(additionalValue.width / 64, 40);
        additionalValue.pivot.x = additionalValue.width * 0.5;
        additionalValue.alpha = 0;
        additionalValue.scale.set(0, 0);

        const nudgeGlow: PIXI.Sprite = new PIXI.Sprite(BruteForce.assetLoader.getTextures("nudgeMutliGlow")[0]);
        nudgeGlow.anchor.set(0.5, 0.5);
        nudgeGlow.blendMode = BLEND_MODES.ADD;
        nudgeGlow.position.set(0, -32);
        nudgeGlow.alpha = 0;
        nudgeGlow.scale.set(0, 0);
        nudgeGlow.name = "multibackglow";

        const nudgeGlowLineEffects: PIXI.Sprite = new PIXI.Sprite(BruteForce.assetLoader.getTextures("nudgeMultiLines")[0]);
        nudgeGlowLineEffects.anchor.set(0.5, 0.5);
        nudgeGlowLineEffects.blendMode = BLEND_MODES.ADD;
        nudgeGlowLineEffects.position.set(0, -32);
        nudgeGlowLineEffects.alpha = 0;
        nudgeGlowLineEffects.scale.set(0, 0);
        nudgeGlowLineEffects.name = "multibacklines";

        valueTl.add(() => {
            this._multiplierContainer.addChild(nudgeGlowLineEffects, nudgeGlow, this._nudgeMultiplier, this._multiplierX, additionalValue);
            BruteForceSound.playMeterPoints();
        }, 0);
        valueTl.to(additionalValue.scale, {x: 1, y: 1, duration: 0.3});
        valueTl.to(additionalValue, {alpha: 1, duration: 0.3}, "<");
        valueTl.to(additionalValue.position, {duration: 0.3, y: -15}, "<");
        valueTl.to(this, {duration: 0.4});
        valueTl.to(additionalValue.scale, {x: 0, y: 0, duration: 0.3});
        valueTl.to(additionalValue, {alpha: 0, duration: 0.3}, "<");
        valueTl.to(additionalValue.position, {duration: 0.3, y: -40}, "<");
        valueTl.to([nudgeGlow, nudgeGlowLineEffects], {alpha: 1, duration: 0.25}, "<");
        valueTl.add(() => {
            BruteForceSound.playNudgePointHighlight();
        }, "<");
        valueTl.to([nudgeGlow.scale, nudgeGlowLineEffects.scale], {x: 1, y: 1, duration: 0.25}, "<");
        valueTl.to([nudgeGlow, nudgeGlowLineEffects], {alpha: 0, duration: 0.25}, ">");

        valueTl.add(() => {
            this._multiplierContainer.removeChild(additionalValue, nudgeGlowLineEffects, nudgeGlow);
            additionalValue.destroy();
        }, ">");
        return valueTl;
    }

    private adjustMultiplierText(): void {
        this._nudgeMultiplier.pivot.x = this._nudgeMultiplier.width * 0.5;
        this._multiplierX.position.x = this._nudgeMultiplier.position.x + this._nudgeMultiplier.width;
        this._multiplierX.pivot.x = this._nudgeMultiplier.width * 0.5;
    }


}